import { render, staticRenderFns } from "./leads-header.vue?vue&type=template&id=e96623e2&scoped=true"
import script from "./leads-header.vue?vue&type=script&lang=js"
export * from "./leads-header.vue?vue&type=script&lang=js"
import style0 from "./leads-header.vue?vue&type=style&index=0&id=e96623e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96623e2",
  null
  
)

export default component.exports